import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { eventsApi } from '../api/events.api'
import type { CreateEvenementRequest } from '@/shared/types/evenement'

const EVENTS_KEY = ['evenements']

export function useEtudiantEvents(etudiantId: number | undefined) {
  return useQuery({
    queryKey: [...EVENTS_KEY, 'etudiant', etudiantId],
    queryFn: () => eventsApi.getByEtudiantId(etudiantId!),
    enabled: !!etudiantId,
  })
}

export function useMyEvents() {
  return useQuery({
    queryKey: EVENTS_KEY,
    queryFn: eventsApi.getMyEvents,
  })
}

export function useCreateEvenement() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateEvenementRequest) => eventsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EVENTS_KEY })
    },
  })
}

export function useUpdateEvenement() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: CreateEvenementRequest }) => eventsApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EVENTS_KEY })
    },
  })
}

export function useDeleteEvenement() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => eventsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EVENTS_KEY })
    },
  })
}

export function useMyMatieres() {
  return useQuery({
    queryKey: [...EVENTS_KEY, 'matieres'],
    queryFn: eventsApi.getMyMatieres,
  })
}

export function useMyVacancesPeriodes() {
  return useQuery({
    queryKey: [...EVENTS_KEY, 'vacances-periodes'],
    queryFn: eventsApi.getMyVacancesPeriodes,
  })
}

export function useMyPeriodesExclues() {
  return useQuery({
    queryKey: [...EVENTS_KEY, 'periodes-exclues'],
    queryFn: eventsApi.getMyPeriodesExclues,
  })
}
